import AdImage from 'public/assets/influencer/images/free-template-3.png'

export const themeList = [
  {
    name: 'Marketing',
    value: 'Marketing'
  },
  {
    name: 'Content Marketing',
    value: 'Content Marketing'
  },
  {
    name: 'Organic Marketing',
    value: 'Organic Marketing'
  },
  {
    name: 'Brand Marketing',
    value: 'Brand Marketing'
  }
]

export type leadersData = {
  background: string
  heroTitle: string
  heroDescription: string
  heroImage: StrapiImageFile
  adCard: {
    title: string
    description: string
    ctaTitle: string
    ctaLink: string
    bgColorClassName: string
    image: StrapiImageFile
  }
}
export const globalLeadersData = {
  background: 'linear-gradient(180deg, #1600E5 26.51%, #5F16CD 80.63%)',
  heroTitle: 'Meet Global Marketing Stars',
  heroDescription:
    'Learn from the most inspiring marketing leaders and icons in the world.',
  heroImage: {
    url: '/assets/influencer/images/globalLeadersHero.png',
    alternativeText: 'image',
    height: 233,
    width: 892
  },
  adCard: {
    title: 'The Future of Content Marketing',
    description: 'The Best Content Marketing Advice You’ll Ever Get',
    ctaTitle: 'Download Ebook',
    ctaLink: '/resources/ebook/the-future-of-content-marketing-ebook/',
    bgColorClassName: 'bg-yellow-30 text-gray-80',
    image: {
      url: AdImage.src,
      alternativeText: 'eook-image',
      height: AdImage.height,
      width: AdImage.width
    }
  }
}

export const indianLeadersData = {
  background:
    'linear-gradient(358.41deg, #1F28F8 -1.04%, #265EEC 33.66%, #C916CD 108.18%)',
  heroTitle: 'Meet Indian Marketing Stars',
  heroDescription:
    'Learn from the most inspiring artists, leaders, and icons in the India',
  heroImage: {
    url: '/assets/influencer/images/indianLeaderHero.png',
    alternativeText: 'image',
    height: 233,
    width: 892
  },
  adCard: {
    title: 'The Future of Content Marketing',
    description: 'The Best Content Marketing Advice You’ll Ever Get',
    ctaTitle: 'Download Ebook',
    ctaLink: '/resources/ebook/the-future-of-content-marketing-ebook/',
    bgColorClassName: 'bg-yellow-30 text-gray-80',
    image: {
      url: AdImage.src,
      alternativeText: 'eook-image',
      height: AdImage.height,
      width: AdImage.width
    }
  }
}
